









import { Component, Vue } from 'vue-property-decorator';
import Message from '@/common/components/Message.vue';

@Component({
    components: {
        Message,
    },
})
export default class PageNotFound extends Vue {
    private messageTitle = '404';
    private messageDescription = 'Strona, której szukasz nie istnieje';
}
